<template>
  <Layout class="main-container">
    <!--    搜索块-->
    <Form
      ref="SearchForm"
      class="search-form-container"
      :model="params"
      label-position="left"
      :label-width="80"
    >
      <div class="search-form-container__content">
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="订单编号:" prop="OrderCode">
              <Input
                placeholder="请输入订单编号"
                v-model="params.OrderCode"
                clearable
              />
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="操作人:" prop="MemberCode">
              <Input
                placeholder="请输入操作人编号或手机号"
                v-model="params.MemberCode"
                clearable
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="退款时间:" prop="TempDate">
              <Date-picker
                style="width: 100%"
                clearable
                v-model="params.TempDate"
                ref="date"
                type="datetimerange"
                :options="options"
                placement="bottom-end"
                placeholder="退款时间范围"
                format="yyyy-MM-dd HH:mm:ss"
                @on-change="dateUpdate"
              ></Date-picker>
            </FormItem>
          </Col>
        </Row>
      </div>
      <Row type="flex" justify="space-between" align="bottom" class="mt5">
        <Col span="12" style="text-align: left">
          <Button
            type="success"
            icon="md-add-circle"
            v-if="$canAction(['RefundLog_Search'])"
            @click="exportData"
          >
            导出
          </Button>
        </Col>
        <Col span="12" style="text-align: right">
          <span
            class="search-form-container__arrow_btn"
            @click="$handleHiddenSearch($el)"
          >
            收起
            <Icon type="ios-arrow-up" />
          </span>
          <Button
            class="ml2 search-form-container__button"
            type="primary"
            ghost
            icon="ios-search"
            @click="handleSearch"
          >
            搜索
          </Button>
          <Button
            class="ml2 search-form-container__button"
            @click="handleReset"
          >
            重置
          </Button>
        </Col>
      </Row>
    </Form>
    <!--    table-->
    <Table
      class="mt10 main-table"
      :loading="tableLoading"
      :height="tableHeight"
      ref="dataTable"
      :columns="columns"
      :data="resObj.DataList"
      highlight-row
      size="small"
      @on-sort-change="sortChange"
      stripe
    >
      <template slot="OrderCode" slot-scope="{ row }">
        <Span
          style="color: green; cursor: pointer"
          @click="openOrderDrawer(row, true)"
        >
          {{ row.OrderCode }}
        </Span>
      </template>
    </Table>
    <!--    分页-->
    <Row class="mt10">
      <Col span="24" class="flex-end">
        <Page
          :page-size-opts="[40, 60, 80, 100]"
          :page-size="40"
          :total="resObj.TotalCount"
          :current="resObj.CurrentPage"
          @on-page-size-change="handleChangePageSize"
          @on-change="handleChangePage"
          size="small"
          show-elevator
          show-sizer
          show-total
        />
      </Col>
    </Row>
    <!-- 订单明细信息展示抽屉-->
    <OrderDetailDrawer ref="orderDetailDrawer" />
  </Layout>
</template>

<script>
import api from "@/api";
import Layout from "@/components/layout/index.vue";
import OrderDetailDrawer from "./components/detail-drawer.vue";
import moment from "moment";
export default {
  name: "RefundLog",
  data() {
    return {
      RowID: 0,
      Status: 0,
      tableLoading: false,
      tableHeight: 0,
      BonusLoading: false,
      TempDate: [],
      params: {
        OrderCode: "",
        MemberCode: "13049633979",
        DateBegin: "",
        ateEnd: "",
        Page: 1,
        PageSize: 40,
        SortName: "RefundDate",
        SortOrder: "Desc",
      },
      columns: [
        { title: "收货姓名", key: "ReceiveName", minWidth: 120 },
        { title: "商品名", key: "ProductName", minWidth: 180 },
        { title: "退货数量", key: "ReturnNum", minWidth: 90 },
        { title: "批发单价", key: "Price", minWidth: 90 },
        { title: "总价", key: "TotalPrice", minWidth: 90 },
        { title: "一级代理", key: "MemberName1", minWidth: 120 },
        { title: "二级代理", key: "MemberName2", minWidth: 120 },
        { title: "退款时间", key: "RefundDate", minWidth: 135 },
      ],
      resObj: {
        CurrentPage: 1,
        TotalCount: 0,
        TotalPage: 0,
        DataList: [],
      },
    };
  },
  created() {
    this.loadRefundLogList();
  },
  mounted() {
    const self = this;
    self.$nextTick(() => {
      self.tableHeight = self.$getTableHeight("main-container");
    });
    window.onresize = function () {
      self.$nextTick(() => {
        self.tableHeight = self.$getTableHeight("main-container");
      });
    };
    document.onkeydown = function (event) {
      var e = event || window.event;
      if (self.$route.name === self.$options.name && e && e.keyCode === 13) {
        // enter 键
        self.loadRefundLogList();
      }
    };
    this.$bus.$on("refreshPage", () => {
      if (this.$route.name === this.$options.name) {
        this.params && (this.params = this.$options.data().params);

        this.loadRefundLogList();
      }
    });
  },
  activated() {
    const self = this;
    document.addEventListener("keydown", function (event) {
      var e = event || window.event;
      if (self.$route.name === self.$options.name && e && e.keyCode === 13) {
        // enter 键
        self.loadRefundLogList();
      }
    });
  },
  deactivated() {
    document.removeEventListener("keydown", function () {});
  },
  methods: {
    exportData() {
      try {
        this.$refs.dataTable.exportCsv({
          filename: "退款记录 " + moment().format("YYYY-HH-MM hh点mm分ss秒"),
          columns: this.columns.filter((col, index) => index < 8),
          data: this.resObj.DataList,
        });
      } catch (error) {
        this.$Notice.error({
          title: "错误",
          desc: error,
        });
        // TODO: 记录错误日志
      }
    },
    handleChangePageSize(pagesize) {
      this.params.Page = 1;
      this.params.PageSize = pagesize;
      this.loadRefundLogList();
    },
    handleChangePage(page) {
      this.params.Page = page;
      this.loadRefundLogList();
    },
    // 日期变化方法
    dateUpdate(value) {
      this.params.DateBegin = value[0];
      this.params.DateEnd = value[1];
    },
    async loadRefundLogList() {
      this.tableLoading = true;
      try {
        const res = await api.GetRefundLogList(this.params);
        this.resObj = res.Data;
        this.tableLoading = false;
      } catch (error) {
        this.$Notice.error({
          title: "错误",
          desc: error,
        });
        this.tableLoading = false;
        // TODO: 记录错误日志
      }
    },
    handleSearch() {
      this.params.Page = 1;
      this.loadRefundLogList();
    },
    handleReset() {
      this.TempDate = [];
      this.$refs.SearchForm.resetFields();
      this.loadRefundLogList();
    },
    // 远程排序
    sortChange(result) {
      this.params.SortName = result.key;
      this.params.SortOrder = this.params.SortOrder === "Desc" ? "Asc" : "Desc";
      this.loadRefundLogList();
    },
    onUpdated() {
      this.$delayLoad(() => {
        this.loadRefundLogList();
      });
    },
    async openOrderDrawer(row) {
      try {
        let res = await api.GetOrderByCode({
          code: row.OrderCode,
        });
        if (res.Data) {
          this.$refs.orderDetailDrawer.obj = res.Data;
          this.$refs.orderDetailDrawer.isShow = true;
          this.$refs.orderDetailDrawer.isEdit = false;
        }
      } catch (error) {
        this.$Notice.error({ title: "错误", desc: error });
      }
    },
  },
  components: { OrderDetailDrawer, Layout },
};
</script>
